export enum HistoryActionType {
    status = "Status Changed",
    location = "Location Changed",
    notes = "Notes viewed"
}